import React from "react";
import PropTypes from "prop-types";

export default function ColorTableRow(props) {
  return (
    <tr>
      <td className="align-middle">
        {props.colorCode && (
          <div
            className="color-circle"
            style={{
              backgroundColor: props.colorCode,
              borderColor: props.borderColor,
              color: props.textColor,
            }}
          >
            {props.colorName && (
              <div className="font-weight-bold text-center small">
                {props.colorName}
              </div>
            )}
          </div>
        )}
      </td>
      <td className="align-middle">
        {props.hex && <div>Hex: {props.hex} </div>}
        {props.rgb && <div>RGB: {props.rgb}</div>}
      </td>

      <td className="align-middle">
        {props.cmyk && <div>CMYK: {props.cmyk}</div>}
      </td>

      <td className="align-middle">
        {props.pms && <div>PMS: {props.pms}</div>}
      </td>
    </tr>
  );
}

ColorTableRow.propTypes = {
  colorCode: PropTypes.string,
  textColor: PropTypes.string,
  borderColor: PropTypes.string,
  colorName: PropTypes.string,
  hex: PropTypes.string,
  rgb: PropTypes.string,
  cmyk: PropTypes.string,
  pms: PropTypes.string,
};

ColorTableRow.defaultProps = {
  borderColor: "none",
};
